// === INPACT:SLUITSTRAAT:BOILERPLATE:ROUTER:v1 ===

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import NotFoundPage from './pages/NotFoundPage';
import SettingsPage from './pages/SettingsPage';
import CustomerInformationPage from './pages/CustomerInformationPage';
import ModuleSelectionPage from './pages/ModuleSelectionPage';
import SluitstraatInformationPage from './pages/SluitstraatInformationPage';
import WorkflowConfigurationPage from './pages/WorkflowConfigurationPage';
import TextsPage from './pages/TextsPage';

// Generated workflow screens
import ProductSelectionScreen from './pages/screens/ProductSelectionScreen';
import ClientInformationScreen from './pages/screens/ClientInformationScreen';
import WoonhuisScreen from './pages/screens/WoonhuisScreen';
import InboedelScreen from './pages/screens/InboedelScreen';
import AansprakelijkheidScreen from './pages/screens/AansprakelijkheidScreen';
import PersonenAutoScreen from './pages/screens/PersonenAutoScreen';
import RechtsbijstandScreen from './pages/screens/RechtsbijstandScreen';
import DoorlopendeReisScreen from './pages/screens/DoorlopendeReisScreen';
import OngevallenScreen from './pages/screens/OngevallenScreen';
import PaymentInformationScreen from './pages/screens/PaymentInformationScreen';
import WorkflowSummaryScreen from './pages/screens/WorkflowSummaryScreen';
import AcceptanceQuestionsScreen from './pages/screens/AcceptanceQuestionsScreen';
import ConfirmationScreen from './pages/screens/ConfirmationScreen';
import EndPageScreen from './pages/screens/EndPageScreen';


/**
 * Router Component
 *
 * Base routing configuration for all Sluitstraat instances.
 *
 * DEFAULT ROUTES:
 * - / → HomePage (landing page)
 * - /workflow → Add WorkflowPage in customer instance
 * - /404 → NotFoundPage
 *
 * CUSTOMIZATION:
 * For customer instances, add routes as needed:
 * - import WorkflowPage from './pages/WorkflowPage';
 * - <Route path="/workflow" element={<WorkflowPage />} />
 *
 * PRODUCTION TIP:
 * For direct-to-workflow approach, change root route:
 * - <Route path="/" element={<Navigate to="/workflow" replace />} />
 */
const Router: React.FC = () => {
  return (
    <Routes>
      {/* Root route - Redirect to workflow */}
      <Route path="/" element={<Navigate to="/workflow/product-selection" replace />} />

      {/* Settings routes */}
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/settings/customer" element={<CustomerInformationPage />} />
      <Route path="/settings/module" element={<ModuleSelectionPage />} />
      <Route path="/settings/sluitstraat" element={<SluitstraatInformationPage />} />
      <Route path="/settings/workflow" element={<WorkflowConfigurationPage />} />
      <Route path="/settings/content" element={<TextsPage />} />

      {/* Generated workflow screens */}
      <Route path="/workflow" element={<Navigate to="/workflow/product-selection" replace />} />
      <Route path="/workflow/product-selection" element={<ProductSelectionScreen />} />

      <Route path="/workflow/client-information" element={<ClientInformationScreen />} />

      {/* Product screens */}
      <Route path="/workflow/personenauto" element={<PersonenAutoScreen />} />
      <Route path="/workflow/woonhuis" element={<WoonhuisScreen />} />
      <Route path="/workflow/inboedel" element={<InboedelScreen />} />
      <Route path="/workflow/aansprakelijkheid" element={<AansprakelijkheidScreen />} />
      <Route path="/workflow/rechtsbijstand" element={<RechtsbijstandScreen />} />
      <Route path="/workflow/ongevallen" element={<OngevallenScreen />} />
      <Route path="/workflow/doorlopendereis" element={<DoorlopendeReisScreen />} />

      {/* Quote flow - Final screen */}
      <Route path="/workflow/summary" element={<WorkflowSummaryScreen />} />

      {/* Application flow screens */}
      <Route path="/workflow/payment-information" element={<PaymentInformationScreen />} />
      <Route path="/workflow/acceptance-questions" element={<AcceptanceQuestionsScreen />} />
      <Route path="/workflow/confirmation" element={<ConfirmationScreen />} />
      <Route path="/workflow/end" element={<EndPageScreen />} />

      {/* Error routes */}
      <Route path="/404" element={<NotFoundPage />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
};

export default Router;
